import React from 'react'

interface IProps {
    className?: string
    children?: any
}

const TableHeader: React.FC<IProps> = ({className, children}) => {
    return (
        <div className={`flex-1 grid items-center bg-line02 px-[20px] py-[10px] rounded-[7px] gap-[12px] ${className}`}>
            {children}
        </div>
    )
}

export default TableHeader
